import { lazy } from "react";

import { SettingsPaths } from "Pages/settings/paths";

import { SIPPaths } from "../paths";
import SipRouter from "../SipRouter";

import type { RegalRouteObject } from "App/routes/types";

const SipDomainListPage = lazy(() => import("./SipDomainListPage/SipDomainListPage"));
const SipDomainDetailsPage = lazy(() => import("./SipDomainDetailsPage/SipDomainDetailsPage"));
const SipDomainCreatePage = lazy(() => import("./SipDomainCreatePage/SipDomainCreatePage"));
const IpAccessControlListPage = lazy(() => import("./IpAccessControlListPage/IpAccessControlListPage"));

export const sipRoute: RegalRouteObject = {
    path: `${SettingsPaths.sip}/*`,
    element: <SipRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <SipDomainListPage />,
        },
        {
            path: SIPPaths.sipDomains,
            element: <SipDomainListPage />,
        },
        {
            path: SIPPaths.sipDomainNew,
            element: <SipDomainCreatePage />,
        },
        {
            path: SIPPaths.sipDomainDetails,
            element: <SipDomainDetailsPage />,
        },
        {
            path: SIPPaths.ipAccessControlLists,
            element: <IpAccessControlListPage />,
        },
    ],
};
